import React from 'react';
import { Datagrid } from 'react-admin';

import { DateTimeField } from 'components/fields/DateFormatField';
import { SelectEnumField } from 'components/fields/SelectEnumField';
import { AppSecretType } from 'entities/AppSecretType';

import { AppSecretRowActions } from './AppSecretRowActions';


export const AppSecretsDatagrid = (props) => (
	<Datagrid rowClick="show" {...props}>
		<SelectEnumField source="type" enumObj={AppSecretType} enumName="app_secret_type" />
		<DateTimeField source="created_at" withLocalTimeZone />
		<AppSecretRowActions />
	</Datagrid>
);
